<div
    class="flight-summary-icons icon-summary"
    [popover]="summaryPopover"
    triggers="mouseenter:mouseleave"
    placement="bottom"
    container="body"
>
    <span class="icon-summary-item">
        <i class="far fa-plane"></i> {{ totalFlights }}
    </span>
    <span class="icon-summary-item">
        <i class="fal fa-map"></i> {{ flightsWithLogs }}
    </span>
    <span class="icon-summary-item">
        <i class="far fa-stopwatch"></i> {{ timerFlights }}
    </span>
    <span class="icon-summary-item">
        <i class="far fa-pencil"></i> {{ manualFlights }}
    </span>
    <span
        class="icon-summary-item"
        *ngIf="hasFlightLogging && unassignedFlightLogsCount > 0"
    >
        <i class="far fa-link-slash"></i> {{ unassignedFlightLogsCount }}
    </span>
</div>

<ng-template #summaryPopover>
    <div class="icon-summary-popover">
        <div class="icon-summary-popover-row">
            <span>Total flights</span>
            <span>{{ totalFlights }}</span>
        </div>
        <div class="icon-summary-popover-row">
            <span>Flights with logs</span>
            <span>{{ flightsWithLogs }}</span>
        </div>
        <div class="icon-summary-popover-row">
            <span>FA timer flights</span>
            <span>{{ timerFlights }}</span>
        </div>
        <div class="icon-summary-popover-row">
            <span>Manual flights</span>
            <span>{{ manualFlights }}</span>
        </div>
        <div
            class="icon-summary-popover-row"
            *ngIf="hasFlightLogging && unassignedFlightLogsCount > 0"
        >
            <span>Unassigned flight logs</span>
            <span>{{ unassignedFlightLogsCount }}</span>
        </div>
    </div>
</ng-template>
